import { DateTime } from "luxon";

/**
 * Get a JavaScript Date object from an ISO 8601 date string, preserving the local time.
 * @param date ISO 8601 date string
 * @returns JavaScript Date object
 */
export const getJSDate = (date: string): Date => {
    const dateTimeUTC = DateTime.fromISO(date, { zone: 'utc' });
    const dateTime = DateTime.fromISO(date).set(dateTimeUTC.toObject());

    return dateTime.toJSDate();
}